<template>
  <div>

    <h3 class="title has-text-centered is-size-5" :class="'has-text-' + secondaryColor">{{ $t('orders.cartContent') }}</h3>

    <div class="box has-background-white-bis p-4">
      <p v-if="cartGroups.length === 0" class="has-text-centered has-text-grey">
        {{ $t('orders.zeroItems') }}
      </p>
      <template v-else v-for="cartGroup in cartGroups">

        <div class="component-cart-info is-size-6">
          <strong><small :class="'has-text-' + secondaryColor">{{ cartGroup.name }}</small></strong>
        </div>

        <div v-for="cartLine in cartGroup.cart_lines" class="component-cart-info is-size-7">
          <div class="is-flex is-width-100 is-justify-content-space-between">
            <span>
              <span class="has-text-success has-text-weight-bold">{{ cartLine.amount }}x</span>
              {{ cartLine.name }}
            </span>
            <span class="is-white-space-nowrap ml-2 has-text-success has-text-weight-bold">{{ cartLine.price_formatted }}</span>
          </div>
        </div>

      </template>
    </div>

    <div class="has-text-centered" v-if="cartGroups.length > 0">
      <a class="button is-danger is-small" :href="cartUrl">
        <span class="icon icon--0 is-small"><i class="fas fa-shopping-cart"></i></span>
        <span>{{ $t('orders.actions.order') + ' ' + itemPriceFormatted }}</span>
      </a>
    </div>

  </div>
</template>

<script>
import cartGetters from "../../../store/web/cart/getter-types";

export default {
  props: {
    cartUrl: String,
    secondaryColor: String,
  },
  computed: {
    cartGroups() {
      return this.$store.getters['cart/' + cartGetters.GET_CART_GROUPS];
    },
    itemPriceFormatted() {
      return this.$store.getters['cart/' + cartGetters.GET_ITEM_PRICE_FORMATTED];
    }
  }
}
</script>

<style lang="sass">
  @import "../../../../../resources/sass/variables/wistro"
  .component-cart-info
    &+&
      padding-top: .5rem
      margin-top: .5rem
      border-top: 1px solid $grey-lighter
</style>
